import { DateRangeSchema } from '@/utils';
import { z } from 'zod';
import { EXPENDITURE_ITEM_NATURES_CODE_LENGTH } from '../utils';
import { getCodeMaxValue } from '../utils/get-code-max-value';

const ExpenditureItemNatureBaseModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  code: z
    .number()
    .min(1)
    .max(getCodeMaxValue(EXPENDITURE_ITEM_NATURES_CODE_LENGTH)),
  name: z.string(),
  startYear: z.number().int().nullable(),
  endYear: z.number().int().nullable(),
  level: z.number().int(),
  upperId: z.string().uuid().nullable(),
});

export const ExpenditureItemNaturesModel =
  ExpenditureItemNatureBaseModel.array();

const ExpenditureItemNaturePresetBaseModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  startYear: z.number().int().nullable(),
  endYear: z.number().int().nullable(),
  expenditureNatureId: z.string().uuid(),
  expenditureItemNatureId: z.string().uuid(),
});

export const ExpenditureItemNaturePresetsModel =
  ExpenditureItemNaturePresetBaseModel.array();

export const ExpenditureItemNaturePresetFormSchema = z.object({
  period: DateRangeSchema.nullish(),
  expenditureNatureIds: z.string().uuid().array(),
  expenditureItemNatureIds: z.string().uuid().array(),
});
